import { type FC } from 'react';
import { ContentItemIcon } from 'ContentItemIcon';
import { ClickableText } from 'ClickableText';
import { type CourseCard } from '../StreamDashboard.types';

/*
    Course links for the recommended and related boxes. Primary, semibold and 15px, as the legacy
    sidebar-box mixin styled them. primary is the Quantic coral and follows the brand.
*/

type Props = {
    courses: CourseCard[];
    onSelectCourse: (courseId: string) => void;
};

export const CourseCardList: FC<Props> = ({ courses, onSelectCourse }) => (
    /* !list-none and !ps-0 beat `.stream-dashboard ul { list-style: disc; padding-left: 1.75em }` in
       oreo/global/tailwind.scss, a descendant selector with specificity (0,1,1) that outranks a
       single utility class. The override stops being necessary in the PR that removes the
       .stream-dashboard root class. */
    <ul className="m-0 !list-none p-0 !ps-0">
        {courses.map(course => (
            <li key={course.id} className="mt-3.5 first:mt-0">
                <ClickableText
                    onPress={() => onSelectCourse(course.id)}
                    color="primary"
                    weight="semibold"
                    underline="none"
                    allowWrap
                    className="flex items-center gap-2.5 text-start text-sm"
                >
                    <ContentItemIcon src={course.imageSrc} alt={course.title} size={7.5} cacheForever />
                    <span className="uppercase">{course.title}</span>
                </ClickableText>
            </li>
        ))}
    </ul>
);
